import React from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";

import DefaultValuesUtils from "../../utils/classes/DefaultValuesUtils";

const useStyles = makeStyles((theme) => ({
  anchorContainer: {
    width: "80%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-end",
  },

  anchor: {
    cursor: "pointer",
    textAlign: "right",
    transition: "all 0.30s ease",
    "&:hover": {
      textDecoration: "underline",
      transform: "translateY(-5px)",
      color: theme.palette.secondary.ackCheck,
    },
  },
}));

const ForgotPasswordRedirector = () => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();
  const history = useHistory();



  //  ***************
  //  ** Functions **
  //  ***************
  const redirectToPasswordReset = () => { history.push(DefaultValuesUtils.ROUTES[103]); };



  //  ************
  //  ** Return **
  //  ************
  return (
    <div className={classes.anchorContainer}>
      <span className={classes.anchor} onClick={redirectToPasswordReset}>
        {i18n.t("forgotPasswordAnchor.text")}
      </span>
    </div>
  );
};

export default ForgotPasswordRedirector;
